/**
 * MultiView event names
 * @public
 */
export const MultiViewEventNames = {
    hiddenChange: "hidden-change"
};
//# sourceMappingURL=multi-view.options.js.map